import { defineMessages } from 'react-intl';

export const scope = 'app.components.AssessmentStageBuilder';

// Legacy strings elsewhere in the builder remain hardcoded migration debt.
export const messages = defineMessages({
  createTemplate: { id: `${scope}.createTemplate`, defaultMessage: 'Create Template' },
  cancel: { id: `${scope}.cancel`, defaultMessage: 'Cancel' },
  submit: { id: `${scope}.submit`, defaultMessage: 'Submit' },
  selectStagesInstruction: {
    id: `${scope}.selectStagesInstruction`,
    defaultMessage: 'Select a contiguous set of stages to save as a template',
  },
  selectAtLeastOne: { id: `${scope}.selectAtLeastOne`, defaultMessage: 'Select at least one stage' },
  selectContiguous: { id: `${scope}.selectContiguous`, defaultMessage: 'Select a contiguous set of stages' },
  selectionDisabledTooltip: {
    id: `${scope}.selectionDisabledTooltip`,
    defaultMessage: 'Selection must be a contiguous set of stages',
  },
  stageTitleLabel: { id: `${scope}.stageTitleLabel`, defaultMessage: 'Stage title (optional)' },
  routesDerivedExplainer: {
    id: `${scope}.routesDerivedExplainer`,
    defaultMessage: "Routing is derived for each band's roster when the template is applied.",
  },
  useTemplate: { id: `${scope}.useTemplate`, defaultMessage: 'Use a Template' },
  useTemplateSubtitle: { id: `${scope}.useTemplateSubtitle`, defaultMessage: '(Apply a pre-built schedule)' },
  stageNotCompleted: {
    id: `${scope}.stageNotCompleted`,
    defaultMessage: "The stage wasn't marked complete. Please try again.",
  },
  stageNotAdvanced: {
    id: `${scope}.stageNotAdvanced`,
    defaultMessage: "The stage was completed, but the age group didn't move to the next stage. Please try again.",
  },
});
